export default {
  mouseclickspot:`<hotspot name="mousespot" devices="mouse" type="text" html="" css="font-size:80px;text-align:center;" vcenter="true" width="200" height="200" scale="0.5"
        bgalpha="0.5" bgroundedge="100" bgborder="2 0x000000 1" bgshadow="0 0 5 0xFFFFFF 1.0" oversampling="2" mipmapping="true" zorder="1" depth="0" depthbuffer="true"
        torigin="world" rotationorder="xyz" rx="-90" capture="false" handcursor="true" visible="false" onloaded="stickMouse();" onclick="jscall(clickAddMemo())"/>`
  ,stickmouseaction:`<action name="stickMouse" scope="local">
      set(d,1);
      asyncloop(caller.loaded,
        if(get(caller.visible),
          <!-- 마우스 위치를 구면 좌표(h, v)로 변환 -->
          screentosphere(mouse.x,mouse.y, h,v);

          set(math, h);  <!-- 수평 각도 -->
          set(matv, v);  <!-- 수직 각도 -->

          <!-- 구면 좌표(h,v)를 3D 방향 벡터(dx, dy, dz)로 변환 -->
          spheretospace(h,v,d, dx,dy,dz);
          <!-- 충돌을 계산할 3D 평면 정의 -->
          calc(y_plane, -1000 + 160);  <!-- 바닥 위치 (oy 조정 포함) -->
          set(z1_plane, -1000);        <!-- 왼쪽 벽 -->
          set(z2_plane,  1000);        <!-- 오른쪽 벽 -->
          set(x1_plane, -1000);        <!-- 앞 벽 -->
          set(x2_plane,  1000);        <!-- 뒷 벽 -->

          <!-- 각 평면과의 충돌 거리(scale)를 계산 (dy, dz, dx가 0일 경우 -1) -->
          calc(scale_y,  dy != 0 ? (y_plane  / dy) : -1);
          calc(scale_z1, dz != 0 ? (z1_plane / dz) : -1);
          calc(scale_z2, dz != 0 ? (z2_plane / dz) : -1);
          calc(scale_x1, dx != 0 ? (x1_plane / dx) : -1);
          calc(scale_x2, dx != 0 ? (x2_plane / dx) : -1);

          <!-- 유효하지 않은 scale(-1 이하) 값은 무시되도록 아주 큰 값으로 대체 -->
          if(scale_y  LT 0, set(scale_y,  99999));
          if(scale_z1 LT 0, set(scale_z1, 99999));
          if(scale_z2 LT 0, set(scale_z2, 99999));
          if(scale_x1 LT 0, set(scale_x1, 99999));
          if(scale_x2 LT 0, set(scale_x2, 99999));

          <!-- 가장 가까운 평면을 찾기 위한 최소 scale 계산 -->
          copy(minscale, scale_y);
          copy(face, 'y');
          if(scale_z1 LT minscale, copy(minscale, scale_z1), copy(face, 'z1'));
          if(scale_z2 LT minscale, copy(minscale, scale_z2), copy(face, 'z2'));
          if(scale_x1 LT minscale, copy(minscale, scale_x1), copy(face, 'x1'));
          if(scale_x2 LT minscale, copy(minscale, scale_x2), copy(face, 'x2'));

          <!-- 최소 거리 방향으로 실제 3D 위치 계산 -->
          calc(x, dx * minscale);
          calc(y, dy * minscale);
          calc(z, dz * minscale);

          <!-- 현재 뷰의 위치 + 상대 좌표로 핫스팟 위치 이동 -->
          calc(caller.tx, view.tx - view.ox_rotated + x);
          calc(caller.ty, view.ty - view.oy_rotated + y);
          calc(caller.tz, view.tz - view.oz_rotated + z);
        );
      );
    </action>`
    ,arrow:`<connection name="_arrowname_"
	                hdir="_arrow_hdir_"
	                vdir="0"
	                arrowstyle="default-arrow"
	                shadowstyle="default-shadow"
	                onover="jscall(console.log('_arrowname_onover_'))"
	                onout="jscall(console.log('_arrowname_onout_'))"
	                onclick="jscall(console.log('_arrowname_onclick_'))"
	                shape="default-arrow-shape"
	                shadow="true"
	                />`
}
